/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Type_TranslationInputs */

const en_edit_event_group_type_translation = /** @type {(inputs: Edit_Event_Group_Type_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation`)
};

const fr_edit_event_group_type_translation = /** @type {(inputs: Edit_Event_Group_Type_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduction`)
};

const de_edit_event_group_type_translation = /** @type {(inputs: Edit_Event_Group_Type_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung`)
};

const it_edit_event_group_type_translation = /** @type {(inputs: Edit_Event_Group_Type_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduzione`)
};

const ru_edit_event_group_type_translation = /** @type {(inputs: Edit_Event_Group_Type_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перевод`)
};

const es_edit_event_group_type_translation = /** @type {(inputs: Edit_Event_Group_Type_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traducción`)
};

const zh_cn2_edit_event_group_type_translation = /** @type {(inputs: Edit_Event_Group_Type_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译`)
};

const ja_edit_event_group_type_translation = /** @type {(inputs: Edit_Event_Group_Type_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳`)
};

const hi_edit_event_group_type_translation = /** @type {(inputs: Edit_Event_Group_Type_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद`)
};

const pt_pt2_edit_event_group_type_translation = /** @type {(inputs: Edit_Event_Group_Type_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradução`)
};

/**
* | output |
* | --- |
* | "Translation" |
*
* @param {Edit_Event_Group_Type_TranslationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_type_translation = /** @type {((inputs?: Edit_Event_Group_Type_TranslationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Type_TranslationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_type_translation(inputs)
	if (locale === "de") return de_edit_event_group_type_translation(inputs)
	if (locale === "it") return it_edit_event_group_type_translation(inputs)
	if (locale === "ru") return ru_edit_event_group_type_translation(inputs)
	if (locale === "es") return es_edit_event_group_type_translation(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_type_translation(inputs)
	if (locale === "ja") return ja_edit_event_group_type_translation(inputs)
	if (locale === "hi") return hi_edit_event_group_type_translation(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_type_translation(inputs)
	return en_edit_event_group_type_translation(inputs)
});